
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'commandes': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 0.75C2.25004 0.335804 2.5858 4.14134e-05 3 0H16.5C16.9142 4.14134e-05 17.25 0.335804 17.25 0.75V14.25C17.25 16.2869 15.6024 17.9551 13.5747 17.9956C13.5499 17.9983 13.525 17.9998 13.5 18H3.75C1.68786 18 0 16.3121 0 14.25C4.14134e-05 13.8358 0.335804 13.5 0.75 13.5H2.25V0.75ZM15.75 1.5H3.75V13.5H10.5C10.9142 13.5 11.25 13.8358 11.25 14.25C11.25 15.5014 12.2486 16.5 13.5 16.5C14.7514 16.5 15.75 15.5014 15.75 14.25V1.5ZM6 3.75V5.25H7.5V3.75H6ZM9 5.25V3.75H13.5V5.25H9ZM6 6.75V8.25H7.5V6.75H6ZM9 8.25V6.75H13.5V8.25H9ZM6 9.75V11.25H7.5V9.75H6ZM9 11.25V9.75H13.5V11.25H9Z"/>'
  }
})
